module.exports = __webpack_public_path__ + "static/biodiversity_HR-772e29e9e07bfe500d2880e0816f292f.mp4";